import { RoleType } from './api';

export type NotificationEventType =
  | 'complaint_created'
  | 'complaint_assigned'
  | 'vendor_assigned'
  | 'work_order_created'
  | 'work_accepted'
  | 'work_started'
  | 'work_completed'
  | 'verification_required'
  | 'new_comment'
  | 'vendor_response'
  | 'complaint_closed'
  | 'sla_warning'
  | 'sla_breached';

export type NotificationChannel = 'in_app' | 'email' | 'sms' | 'whatsapp';

export interface Notification {
  id: string;
  event_type: NotificationEventType;
  title: string;
  message: string;
  entity_type: 'complaint' | 'work_order' | 'vendor';
  entity_id: string;
  recipient_user_id: string;
  recipient_role: RoleType;
  is_read: boolean;
  channel: NotificationChannel;
  created_at: string;
}

export interface NotificationFilter {
  recipient_user_id?: string;
  is_read?: boolean;
  event_type?: NotificationEventType;
  entity_type?: string;
}

export const EVENT_TYPE_LABELS: Record<NotificationEventType, string> = {
  complaint_created: 'Complaint Created',
  complaint_assigned: 'Complaint Assigned',
  vendor_assigned: 'Vendor Assigned',
  work_order_created: 'Work Order Created',
  work_accepted: 'Work Accepted',
  work_started: 'Work Started',
  work_completed: 'Work Completed',
  verification_required: 'Verification Required',
  new_comment: 'New Comment',
  vendor_response: 'Vendor Response',
  complaint_closed: 'Complaint Closed',
  sla_warning: 'SLA Warning',
  sla_breached: 'SLA Breached',
};

export const EVENT_TYPE_ICONS: Record<NotificationEventType, string> = {
  complaint_created: 'bg-sky-500/10 text-sky-400',
  complaint_assigned: 'bg-sky-500/10 text-sky-400',
  vendor_assigned: 'bg-amber-500/10 text-amber-400',
  work_order_created: 'bg-sky-500/10 text-sky-400',
  work_accepted: 'bg-emerald-500/10 text-emerald-400',
  work_started: 'bg-emerald-500/10 text-emerald-400',
  work_completed: 'bg-emerald-500/10 text-emerald-400',
  verification_required: 'bg-purple-500/10 text-purple-400',
  new_comment: 'bg-slate-500/10 text-slate-400',
  vendor_response: 'bg-amber-500/10 text-amber-400',
  complaint_closed: 'bg-emerald-500/10 text-emerald-400',
  sla_warning: 'bg-amber-500/10 text-amber-400',
  sla_breached: 'bg-rose-500/10 text-rose-400',
};
